import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../../../redux/store";
import { fetchGamecardCategories } from "../../../../features/auth/store/gamecardCategorySlice";
import GamecardCategoriesTable from "./GamecardCategoriesTable";
import { CreateGamecardCategoryModal } from "../../Modal/Gamecard/CreateGamecardCategoryModal";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { Button } from "../../../../components/Reusable/Button";
import { EditGameCardCategoryModal } from "../../Modal/Gamecard/EditGamecardCategoryModal";
import { DeleteGamecardCategoryModal } from "../../Modal/Gamecard/DeleteGamecardCategoryModal";

const GamecardCategories: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const { gamecardCategories, loading, error } = useSelector(
    (state: RootState) => state.gamecardCategories
  );

  useEffect(() => {
    dispatch(fetchGamecardCategories());
  }, [dispatch]);

  const openDeleteModal = async (id: number) => {
    setSelectedCategory(id);
    setIsDeleteModalOpen(true);
  };

  const openEditModal = async (id: number) => {
    setSelectedCategory(id);
    setIsEditModalOpen(true);
  };

  // Filter and search logic
  const filteredCategories = gamecardCategories.filter((category) => {
    const matchesStatus = !statusFilter || category.status === statusFilter;
    const matchesSearch =
      !searchTerm ||
      category.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Game Card Categories">
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4 mb-4 w-full">
              <input
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border p-2 rounded"
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="border p-2 rounded"
              >
                <option value="">All Status</option>
                <option value="on">Active</option>
                <option value="off">Inactive</option>
              </select>
            </div>
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
              textColor="text-white"
              borderRadius="rounded-lg"
              className="w-[200px] h-10 ml-6"
            >
              New Category
            </Button>
          </div>

          <GamecardCategoriesTable
            categories={filteredCategories}
            loading={loading}
            onDelete={openDeleteModal}
            onEdit={openEditModal}
          />

          <CreateGamecardCategoryModal
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
          />

          <EditGameCardCategoryModal
            isOpen={selectedCategory !== null && isEditModalOpen}
            id={selectedCategory}
            onClose={() => {
              setIsEditModalOpen(false);
              setSelectedCategory(null);
            }}
          />

          <DeleteGamecardCategoryModal
            id={selectedCategory}
            isOpen={isDeleteModalOpen}
            onClose={() => {
              setIsDeleteModalOpen(false);
              setSelectedCategory(null);
            }}
          />
        </InternalContainer>
      </div>
    </ExternalContainer>
  );
};

export default GamecardCategories;
